import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { DOCUMENT_ISSUING_DISCIPLINE_PREFIX_URL } from './constants/config.document-issuing-discipline'

const ListPage = lazy(
  () => import('./pages/ListPage.DocumentIssuingDiscipline')
)

const DocumentIssuingDisciplineRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_ISSUING_DISCIPLINE_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default DocumentIssuingDisciplineRouters
